export default "__VITE_ASSET__DOjOpaVt__"